module.exports = __webpack_public_path__ + "img/3.05.a849f9fe.jpg";